<template>
  <ul class="TemplateSelector">
    <li
      v-for="template in templates"
      :key="template.type"
      class="TemplateItem"
      :class="{'is-selected': highlight && value === template.type}"
      @click="$emit('select', template.type)"
    >
      <img
        v-if="template.type && loadImages"
        class="TemplateItem-image"
        :src="require(`./images/templates/${template.type}.png`)"
        :alt="template.label"
      />
      <div v-else class="TemplateItem-noImage">
        <lm-material-icon icon="add" />
      </div>
      <h1 class="TemplateItem-title">{{ template.label }}</h1>
    </li>
  </ul>
</template>

<script>
import LmMaterialIcon from '@/components/ui/LmMaterialIcon'

export default {
  name: 'TemplateSelector',
  components: {LmMaterialIcon},
  props: {
    value: {
      type: String,
      default: ''
    },
    highlight: {
      type: Boolean,
      default: false
    },
    loadImages: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      domain: process.env.VUE_APP_DOMAIN,
      templates: [
        {
          type: '',
          label: 'Blank',
          name: '',
          description: ''
        },
        {
          type: 'canvas',
          label: 'Business Model Canvas',
          name: 'Business Model Canvas',
          description: 'Landscape template for Business Model Canvas'
        },
        {
          type: 'porters',
          label: "Porter's five forces",
          name: "Porter's five forces",
          description:
            "Landscape of Porter's Five Forces extended to include complementers and regulators"
        },
        {
          type: 'pestel',
          label: 'Pestel',
          name: 'Pestel',
          description: 'Map for the PESTEL strategic framework'
        },
        {
          type: 'startups',
          label: "Startups' Map",
          name: "Startups' Map",
          description:
            'Map of startups including business model and market structure maps'
        },
        {
          type: 'innovation',
          label: 'Innovation',
          name: 'Innovation',
          description: 'Mapping the Innovation landscape'
        },
        {
          type: 'landscape-canvas',
          label: 'Landscape Canvas',
          name: 'Landscape Canvas',
          description:
            'Landscape map incorporating the Landscape and the Business Model Canvas'
        }
      ]
    }
  },
  methods: {
    getInfo(type) {
      return this.templates.find(template => template.type === type)
    }
  }
}
</script>

<style>
.TemplateSelector {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
  grid-gap: 16px;
  margin: 20px 0 0;
  .TemplateItem {
    display: flex;
    flex-direction: column;
    align-items: center;
    outline: 1px solid theme('colors.gray.300');
    cursor: pointer;
    &:hover,
    &.is-selected {
      outline: 1px solid theme('colors.gray.700');
    }
    &.is-selected .TemplateItem-title {
      color: theme('colors.gray.900');
    }
    &-image,
    &-noImage {
      width: 100px;
      height: 100px;
      margin: 16px;
      background-color: #f3f3f3;
    }
    &-noImage {
      display: flex;
      justify-content: center;
      align-items: center;
      i {
        font-size: 30px;
        color: #999999;
      }
    }
    &-title {
      margin-bottom: 16px;
      padding: 0 10px;
      font-size: 14px;
      line-height: 1.2;
      text-align: center;
      color: theme('colors.gray.700');
    }
  }
}
</style>
